import { STOREMODULE_ENDPOINT_MAP, STOREMODULE_ENDPOINTMODULE_MAP } from '@/assets/js/config/server'

import http from '@/$plugins/http'

import base from '../base'
import MAINENTITY from '../base/entity-main'
import SEARCH from '../base/entity-search'
import IS from '../base/is'

export default {
  namespaced: true,
  state: base.createState(IS.state, SEARCH.state, MAINENTITY.state, { /* define custom state-properties */ }),
  getters: base.createGetters(IS.getters, SEARCH.getters, MAINENTITY.getters, { /* define custom getters */ }),
  mutations: base.createMutations(IS.mutations, SEARCH.mutations, MAINENTITY.mutations, { /* define custom mutations */ }),
  actions: base.createEntityActions(STOREMODULE_ENDPOINTMODULE_MAP.orders, STOREMODULE_ENDPOINT_MAP.orderparsedata, IS.actions, SEARCH.actions, MAINENTITY.actions, {
    getByOrderId (serverModuleName = '', serverEntityName = '', entityKey = '') {
      return function ({ state, getters, commit, dispatch }, options = {}) {
        return new Promise(resolve => {
          http({
            method: 'get',
            url: `/${serverModuleName}/api/${serverEntityName}/fororder/${options.orderId}`
          })
            .then(response => {
              resolve(response.data)
            })
        })
      }
    }
  })
}
